"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  value: {}
};
var Value = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Value, _React$Component);
  function Value() {
    var _this;
    (0, _classCallCheck2["default"])(this, Value);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Value, [].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onRemove", function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.props.onRemove(_this.props.value);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMouseDown", function (event) {
      if (event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      if (_this.props.onClick) {
        event.stopPropagation();
        _this.props.onClick(_this.props.value, event);
      } else {
        event.stopPropagation();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTouchEndRemove", function (event) {
      // Check if the view is being dragged, In this case
      // we don't want to fire the click event (because the user only wants to scroll)
      if (_this.dragging) return;

      // Fire the mouse events
      _this.onRemove(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTouchMove", function () {
      // Set a flag that the view is being dragged
      _this.dragging = true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTouchStart", function () {
      // Set a flag that the view is not being dragged
      _this.dragging = false;
    });
    return _this;
  }
  (0, _createClass2["default"])(Value, [{
    key: "renderRemoveIcon",
    value: function renderRemoveIcon() {
      var _this$props = this.props,
        disabled = _this$props.disabled,
        onRemove = _this$props.onRemove,
        classNameValueIcon = _this$props.classNameValueIcon,
        testId = _this$props.testId;
      if (disabled || !onRemove) return false;
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: classNameValueIcon,
        "aria-hidden": "true",
        onMouseDown: this.onRemove,
        onTouchEnd: this.handleTouchEndRemove,
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove,
        "data-test-id": testId && "".concat(testId, "-select-remove-icon")
      }, "\xD7");
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var _this$props2 = this.props,
        classNameLabel = _this$props2.classNameLabel,
        disabled = _this$props2.disabled,
        onClick = _this$props2.onClick,
        value = _this$props2.value,
        id = _this$props2.id,
        children = _this$props2.children,
        testId = _this$props2.testId;

      // Defensively, if there are no children, we set the title to undefined so as to
      // remove the property from the DOM.
      // --
      // When using valueRenderer, and Object is passed in the child array.
      // So we also check that child is a primitive.
      var childArray = _react["default"].Children.toArray(children);
      var child = childArray[0];
      var canBeDisplayedAsTooltip = child && (0, _typeof2["default"])(child) !== 'object' && typeof child !== 'function';
      var title = canBeDisplayedAsTooltip ? child : undefined;
      return onClick || value.href ? /*#__PURE__*/_react["default"].createElement("a", {
        className: classNameLabel,
        href: value.href,
        target: value.target,
        title: title,
        onMouseDown: this.handleMouseDown,
        onTouchEnd: this.handleMouseDown,
        "data-test-id": testId && "".concat(testId, "-label-anchor")
      }, children) : /*#__PURE__*/_react["default"].createElement("span", {
        className: classNameLabel,
        role: "option",
        "aria-disabled": disabled,
        "aria-selected": "true",
        id: id,
        title: title,
        "data-test-id": testId && "".concat(testId, "-label-text"),
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-label": this.props['aria-label']
      }, children);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        value = _this$props3.value,
        className = _this$props3.className,
        testId = _this$props3.testId;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(className, value.className),
        style: value.style,
        title: value.title,
        "data-test-id": testId,
        "data-anypoint-component": Value.displayName
      }, this.renderLabel(), this.renderRemoveIcon());
    }
  }]);
  return Value;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Value, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Value, "displayName", 'Value');
//# sourceMappingURL=Value.js.map